export default "__VITE_ASSET__aa6a54d9__"